export interface ICPDState {
  cpdRegions: TCPDRegion[];
  chatId: TChatId;
  modalType: ECPDModalType | null;
  pikLandingChannel: TPikLandingChannel | null;
  cpdDraftStatus: ECPDDraftStatus;
  cpdDraftSource: TCPDDraftSource | null;
  cpdDraftId: number | null;
  cpdDealType: EDealType | null;
  cpdChatIdLoadingStatus: ECPDChatIdLoadingStatus | null;
}

export type TCPDRegion = {
  id: number;
  name: string;
};

export type TChatId = string | null;

export enum ECPDModalType {
  Initial = 'initial',
  PrelandingSearcher = 'prelandingSearcher',
  PrelandingHomeowner = 'prelandingHomeowner',
}

export type TPikLandingChannel =
  // С "агрессивной" всплывашки (вкладка "Риелторы") в каталоге риелторов/АН
  | 'trap_listing_agents_popup'
  // С "агрессивной" всплывашки (вкладка "Агентства") в каталоге риелторов/АН
  | 'trap_listing_agencies_popup'
  // После клика на баннер (вкладка "Риелторы") в каталоге риелторов/АН
  | 'trap_listing_agents_banner'
  // После клика на баннер (вкладка "Агентства") в каталоге риелторов/АН
  | 'trap_listing_agencies_banner';

export enum ECPDDraftStatus {
  Init = 'init',
  Success = 'success',
  Fail = 'fail',
  Loading = 'loading',
}

export type TCPDDraftSource =
  // с "агрессивной" всплывашки (вкладка "Риелторы") в каталоге риелторов/АН
  | 'trapListingAgentsPopup'
  // с "агрессивной" всплывашки (вкладка "Агентства") в каталоге риелторов/АН
  | 'trapListingAgenciesPopup'
  // после клика на баннер (вкладка "Риелторы") в каталоге риелторов/АН
  | 'trapListingAgentsBanner'
  // после клика на баннер (вкладка "Агентства") в каталоге риелторов/АН
  | 'trapListingAgenciesBanner';

export enum ECPDChatIdLoadingStatus {
  Loading = 'loading',
  Success = 'success',
  Fail = 'fail',
}

export enum EDealType {
  /** Покупка **/
  'Buy' = 'buy',
  /** Продажа **/
  'Sale' = 'sale',
  /** Сдача **/
  'Rent' = 'rent',
  /** Аренда **/
  'Tenant' = 'tenant',
  /** Альтернативная сделка **/
  'SellToBuy' = 'sellToBuy',
  /** Клиент не определился **/
  'Unknown' = 'unknown',
}

export enum ECPDEntrySource {
  Banner = 'banner',
  Modal = 'modal',
}
